var render = function render(_c,_vm){return _c('div',{staticClass:"grid-view__cell grid-field-long-text__cell"},[_c('div',{staticClass:"grid-field-long-text"},[_vm._v(_vm._s(_vm.props.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }